
import GwButton from '~/patterns/atoms/button/button.vue';
import GwIcon from '~/patterns/atoms/icon/icon.vue';

export default {
    components: {
        GwButton,
        GwIcon
    },
    props: {
        paymentMethod: {
            type: String,
            default: null,
        }
    },
    data() {
        return {
            dropIn: null
        };
    },
    methods: {
        submitAdyen() {
            this.$emit('submit');
        },
    }
};
